import { render, staticRenderFns } from "./digitalSystem.vue?vue&type=template&id=2bcde564&scoped=true"
import script from "./digitalSystem.vue?vue&type=script&lang=js"
export * from "./digitalSystem.vue?vue&type=script&lang=js"
import style0 from "./digitalSystem.vue?vue&type=style&index=0&id=2bcde564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcde564",
  null
  
)

export default component.exports